<template>
  <FrequentlyAskedQuestions class="faq main-space" />
</template>

<script lang="ts" setup>
import FrequentlyAskedQuestions from '@/features/FrequentlyAskedQuestions.vue';
</script>

<style lang="scss" scoped>
.faq {
  padding: 0 var(--alias-space-20);
}
</style>
